import { Box, Stack, SxProps, Theme, Typography } from "@mui/material";
import Lottie, { useLottie } from "lottie-react";
import { ReactNode } from "react";
import noResultsAnimation from "assets/lottie/NoResults.json";

interface IEmptyDataProps {
  message: ReactNode;
  sx?: SxProps<Theme>;
}

export const EmptyData = ({ message, sx }: IEmptyDataProps) => {
  const { View } = useLottie(
    {
      animationData: noResultsAnimation,
      loop: false,
    },
    {
      width: "200px",
      height: "130px",
    }
  );

  return (
    <Stack
      sx={{ ...{ width: "100%", textAlign: "center" }, ...sx }}
      height="200px"
      alignItems="center"
      justifyContent="center"
    >
      {View}
      <Typography variant="h5">{message}</Typography>
    </Stack>
  );
};

interface IEmptyMessageProps {
  title: ReactNode;
  subtitle: ReactNode;
  sx?: SxProps<Theme>;
}
export const EmptyMessage = ({ title, subtitle, sx }: IEmptyMessageProps) => {
  return (
    <Stack
      sx={{ ...{ width: "100%", textAlign: "center" }, ...sx }}
      height="200px"
      alignItems="center"
      justifyContent="center"
      // alignContent="center"
    >
      <Typography variant="h5">{title}</Typography>
      <Typography variant="body1" color="text.secondary">
        {subtitle}
      </Typography>
    </Stack>
  );
};
